<template>
  <a-tag :color="color" :style="{ textTransform: 'uppercase' }">
    {{ props.typeTag }}
  </a-tag>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  typeId: {
    type: Number,
    required: true
  },
  typeTag: {
    type: String,
    required: true
  }
});

const colorMap = {
  1: 'success',
  2: 'error'
};

const color = computed(() => colorMap[props.typeId] || 'processing');
</script>
